import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { IDynamicElement } from '../../_shared/models/dynamic/dynamic-element.model';
import { IFormButton } from '../../_shared/models/form/form-button.model';
import { ILink } from '../../_shared/models/link.model';

import { ButtonComponent } from '../../button/button.component';

@Component({
    selector: '<sirius-form-button>',
    templateUrl: './form-button.component.html',
    styleUrls: ['./form-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, ReactiveFormsModule]
})
export class FormButtonComponent implements OnInit, IDynamicElement {
    @Input() link: ILink = {
        title: '',
        href: '',
    };

    form!: FormGroup;
    config?: IFormButton;

    ngOnInit(): void {
        if (this.config) {
            this.link = this.config.button.link;
        }
    }
}
